import React from "react";
import styled from "styled-components";
import { Box, Typography, NewIcon as Icon } from "@bca/ui-library";

import KeyDecisionMakerContainer from "../KeyDecisionMakerContainer";
import { KeyDecisionMakerText } from "../mechanicalReport/styledElements/KeyDecisionMakerText";

import SalvageDeclarationsBadge from "./SalvageDeclarationsBadge";

const StyledIconBadge = styled.span`
  background-color: #e5e8e9;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SalvageDeclarations: React.FunctionComponent = () => {
  return (
    <KeyDecisionMakerContainer minHeight="0px">
      <KeyDecisionMakerText smallerGap>
        <Box display="flex" alignItems="end">
          <StyledIconBadge>
            <Icon name="damage" />
          </StyledIconBadge>
          <SalvageDeclarationsBadge />
        </Box>
        <Typography
          m={0}
          variant="h6"
          fontWeight="semiBold"
          color="footer-blue"
        >
          Salvage Declaration
        </Typography>
      </KeyDecisionMakerText>
    </KeyDecisionMakerContainer>
  );
};

export default SalvageDeclarations;
